import ReactPaginate from "react-paginate";
import { motion } from "framer-motion";
/* pagination buttons style find in style.css file -> CustomPaginationButtonsStyle */

const CustomPaginationButtons = ({
  totalPages,
  currentPage,
  getData,
  currentSizePerPage,
}) => {
  const handlePageClick = ({ selected }) => {
    getData(selected + 1, currentSizePerPage);
  };
  const paginationVariants = {
    hidden: {
      opacity: 0,
      y: 200,
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        type: "spring",
        stiffness: 260,
        damping: 20,
        duration: 2,
      },
    },
  };
  const showNextButton = currentPage !== totalPages - 1;
  const showPrevButton = currentPage !== 0;
  return (
    <motion.div
      variants={paginationVariants}
      // initial="hidden"
      animate="visible"
    >
      <ReactPaginate
        breakLabel={
          <span className="">
            <div style={{ paddingLeft: "5px", paddingRight: "5px" }}>...</div>
          </span>
        }
        nextLabel={
          showNextButton ? (
            <span className="paginate_button next">
              <i className="fa-solid fa-angle-right" />
            </span>
          ) : null
        }
        forcePage={currentPage - 1}
        onPageChange={handlePageClick}
        pageRangeDisplayed={0}
        pageCount={totalPages}
        marginPagesDisplayed={1}
        previousLabel={
          showPrevButton ? (
            <span className="paginate_button previous">
              <i className="fa-solid fa-angle-left" />
            </span>
          ) : null
        }
        containerClassName="dataTables_paginate paging_simple_numbers justify-content-center"
        pageClassName="paginate_buttonCustom"
        activeClassName="current"
      />
    </motion.div>
  );
};

export default CustomPaginationButtons;
